import React, { useState } from 'react';
import './History.css';

function History({ items, onItemClick, onClear }) {
  const [showAll, setShowAll] = useState(false);
  const displayItems = showAll ? items : items.slice(0, 5);

  const formatDuration = (seconds) => {
    if (!seconds) return '';
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div className="history">
      <div className="history-header">
        <h3>Recent conversions</h3>
        {items.length > 0 && (
          <button className="btn-clear" onClick={onClear}>
            Clear
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🎶</div>
          <p>No history yet. Search a video to get started!</p>
        </div>
      ) : (
        <div className="history-list">
          {displayItems.map((item, idx) => (
            <div
              key={idx}
              className="history-item"
              onClick={() => onItemClick(item)}
            >
              <img
                src={item.cover || ''}
                alt={item.title}
                className="history-thumb"
                onError={(e) => {
                  e.target.src =
                    'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 80 80%22%3E%3Crect fill=%22%23e5e7eb%22 width=%2280%22 height=%2280%22/%3E%3Ctext x=%2240%22 y=%2240%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-size=%2240%22 fill=%22%239ca3af%22%3E♪%3C/text%3E%3C/svg%3E';
                }}
              />
              <div className="history-info">
                <div className="history-title">{item.title}</div>
                <div className="history-artist">{item.artist}</div>
              </div>
              <div className="history-duration">{formatDuration(item.duration)}</div>
            </div>
          ))}
          {items.length > 5 && (
            <button 
              className="btn-show-more" 
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? 'Show less' : `Show ${items.length - 5} more`}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default History;
